<template>
    <vProjectPreview v-if="nQuestions" :views="views" v-model="chosenView">
        <vPreviewIframe
            :back="faq.transparentBackground ? '' : faq.faqColor"
            :src="`/preview/faqs/${faq.uuid}`"
        />
    </vProjectPreview>
    <CardEmpty
        class="w-full"
        v-else
        :title="$t('faq.empty.title')"
        :icon="emptyIcon"
        :ctaLabel="$t('faq.empty.cta')"
        @add="createQuestion"
    >
        <p>{{ $t("faq.empty.use_templates") }}</p>
        <div class="space-x-3">
            <ButtonSecondarySm
                v-for="template in templates.filter((t) => t.id != 'empty')"
                :key="template.id"
                @click.stop="fillWithExample(template.id)"
            >
                <span>{{ template.value.toLowerCase() }}</span>
            </ButtonSecondarySm>
        </div>
    </CardEmpty>
</template>

<script>
import { FAQ_PREVIEW_KIND } from "@/apps/faq/faq.routes";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import { FaqIcon } from "@easy/ui/icons";
import vPreviewIframe from "@/shared/views/vPreviewIframe.vue";
import vProjectPreview from "@/shared/views/vProjectPreview.vue";
import { FAQ_ROUTE_NAMES } from "@/apps/faq/faq.routes";
import { CardEmpty } from "@easy/ui/cards";
import { ButtonSecondarySm } from "@easy/ui/buttons";

export default {
    name: "FaqProjectPreview",
    components: {
        vPreviewIframe,
        vProjectPreview,
        CardEmpty,
        ButtonSecondarySm,
    },
    mounted() {
        this.$watch(
            () => [this.faq, this.sections, this.size, this.chosenView, this.lang],
            () => this.refreshIframe(),
            {
                immediate: true,
                deep: true,
            }
        );
        this.$watch(
            () => this.chosenView,
            () => this.setIframeLoaded(false)
        );
    },
    data() {
        return {
            chosenView: FAQ_PREVIEW_KIND.faq,
        };
    },
    computed: {
        ...mapState(["lang"]),
        ...mapState("faq", ["faq", "sections"]),
        ...mapGetters("faq", ["nQuestions", "templates"]),
        emptyIcon() {
            return FaqIcon;
        },
        views() {
            return [
                {
                    label: "FAQ",
                    value: FAQ_PREVIEW_KIND.faq,
                    icon: FaqIcon,
                },
            ];
        },
        fontFamilyStyle() {
            return { "font-family": this.faq.fontFamily };
        },
    },
    methods: {
        ...mapMutations("faq", ["setIframeLoaded"]),
        ...mapActions("faq", ["refreshIframe"]),
        ...mapActions("faq/projects", ["saveSnapshot"]),
        createQuestion() {
            this.routeTo(FAQ_ROUTE_NAMES.projectQuestions, "create");
        },
        routeTo(name, open) {
            const { query } = this.$route;
            this.$router.push({ name, query: { ...query, open } });
        },
    },
};
</script>
